module.exports = __webpack_public_path__ + "static/img/logo.ab0f8492.png";